import * as Yup from "yup";

export const TruckScaleFormSchema = Yup.object().shape({
  scaleId: Yup.number()
    .min(1, "Scale is required")
    .required("Scale is required"),
});
